import { Divider, IconName, Row } from '@bytel/trilogy-react';

export default function HomeDivider() {
    return (
        <Row narrow>
            <Divider iconName={IconName.PLUS} />
        </Row>
    );
}
